import type { Label as LabelDto } from './dto';
import type { Label as LabelModel, IconName } from './model';

function getIconNameFromIcon(icon: string): IconName {
  switch (icon) {
    case 'bug':
    case 'confusion':
    case 'conversion':
    case 'frustration':
    case 'issue':
    case 'success':
      return icon;
    default:
      return 'unknown';
  }
}

export function mapLabelDtoToModel(dto: LabelDto): LabelModel {
  return {
    id: String(dto.id),
    iconName: getIconNameFromIcon(dto.icon),
    name: dto.name,
    custom: dto.custom,
    keyName: dto.key_name,
  };
}

export function mapLabelIdsModelToDto(dto: Array<string>): Array<number> | undefined {
  if (dto.length > 0) {
    return dto.map(Number);
  }

  return undefined;
}
